import React from 'react'
import Manager from '../../public/components/Manager'
import AssetAccDiv from './AssetAccDiv'
Ext.require('Ext.Toast')
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length

const config = () => {
    const handelGenerateAssetAcc = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }) => {
        const list = selected && selected.map(o => o.data.id) || []
        Tyan.doPostEvent({
            event: 'CreateAssetAcc',
            data: { list },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    showDetail(props => <AssetAccDiv {...props} id={id} onSave={refreshPage} />)
                }
            }
        })
    }
    return {
        multiSelect: true,
        buttons: [
            { text: '验收申请', handler: that => handelGenerateAssetAcc(that), disabled: disableBatch }
        ],
        columns: [
            { _text: '物料代码', field: 'ReqPurchaseInfo.MaterialNumber', minWidth: 150, search: true, flex: 1 },
            { _text: '物料名称', field: 'ReqPurchaseInfo.MaterialName', minWidth: 150, flex: 1 },
            { _text: '规格型号', field: 'ReqPurchaseInfo.SpecificationModel', minWidth: 150, flex: 1 },
            { _text: '单位', field: 'ReqPurchaseInfo.Unit', minWidth: 80, flex: 1 },
            { _number: '数量', field: 'ReceivedQuantity', minWidth: 80, flex: 1 },
            { _date: '建议采购时间', field: 'ReqPurchaseInfo.PoposalPurchaseDate', minWidth: 150, flex: 1 },
            { _text: '用途', field: 'ReqPurchaseInfo.Purpose', minWidth: 150, flex: 1 },
            { _text: '供应商', field: 'ReqPurchaseInfo.Supplier', minWidth: 250, search: true, flex: 1 },
            { _date: '到货日期', field: 'ReqPurchaseInfo.ArrivalDate', minWidth: 150, flex: 1 },
            { _number: '单价', field: 'ReqPurchaseInfo.LCNoTaxUnit', minWidth: 150, flex: 1, format: '0,000.0000' },
            { _text: '税率(%)', field: 'ReqPurchaseInfo.TaxRate', minWidth: 150, flex: 1 },
            { _number: '含税单价', field: 'ReqPurchaseInfo.LCTaxUnit', minWidth: 150, flex: 1, format: '0,000.0000' },
            { _text: '类别', field: 'Type', minWidth: 150, flex: 1 },
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
        }
    }
}

export default props => <Manager {...props} config={config} />